import { useQuery } from '@tanstack/react-query'
import api from '@/admin/lib/api'
import type { PulseStats } from '@/admin/types/pulse'

// At-a-glance numbers for the Pulse settings page header. Backed by
// GET /api/admin/pulse/stats/ - tenant-scoped, last 7 days.
export function usePulseStats() {
  return useQuery<PulseStats>({
    queryKey: ['pulse-stats'],
    queryFn: () =>
      api.get('/admin/pulse/stats/').then((r) => r.data as PulseStats),
    staleTime: 30_000,
  })
}
